// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"archive_wrapper__P10jT"};